var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"id") : stack1),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"selectedDeviceRef") : depths[1])) != null ? lookupProperty(stack1,"id") : stack1),{"name":"ifEq","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":2,"column":2},"end":{"line":29,"column":11}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <span class=\"form-aside\" id=\"deviceInfoBlockId\">\n      <p class=\"text-block text-block--small\">\n        <span class=\"text-block__text\">"
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"bodyText") : depths[1]), depth0))
    + "</span>\n      </p>\n      <p class=\"text-block\">\n"
    + ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[1][0]) != null ? lookupProperty(stack1,"type") : stack1),"Android",{"name":"ifEq","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data,"blockParams":blockParams,"loc":{"start":{"line":8,"column":6},"end":{"line":26,"column":15}}})) != null ? stack1 : "")
    + "      </p>\n    </span>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"text-block__text\">"
    + container.escapeExpression(container.lambda(((stack1 = blockParams[2][0]) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "</span>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[2][0]) != null ? lookupProperty(stack1,"type") : stack1),"iPhone",{"name":"ifEq","hash":{},"fn":container.program(4, data, 0, blockParams),"inverse":container.program(5, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":10,"column":6},"end":{"line":26,"column":6}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"text-block__text\">"
    + container.escapeExpression(container.lambda(((stack1 = blockParams[3][0]) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "</span>\n";
},"5":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[3][0]) != null ? lookupProperty(stack1,"type") : stack1),"PLATFORM",{"name":"ifEq","hash":{},"fn":container.program(6, data, 0, blockParams),"inverse":container.program(7, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":12,"column":6},"end":{"line":26,"column":6}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    return "          <span class=\"text-block__text\">Biometrics</span>\n";
},"7":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[4][0]) != null ? lookupProperty(stack1,"type") : stack1),"SECURITY_KEY",{"name":"ifEq","hash":{},"fn":container.program(8, data, 0, blockParams),"inverse":container.program(9, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":14,"column":6},"end":{"line":26,"column":6}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    return "          <span class=\"text-block__text\">Security Key</span>\n";
},"9":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[5][0]) != null ? lookupProperty(stack1,"type") : stack1),"FIDO2",{"name":"ifEq","hash":{},"fn":container.program(10, data, 0, blockParams),"inverse":container.program(11, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":16,"column":6},"end":{"line":26,"column":6}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"text-block__text\">PassKey</span>\n";
},"11":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = __default(require("../helpers/ifEq.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[6][0]) != null ? lookupProperty(stack1,"type") : stack1),"TOTP",{"name":"ifEq","hash":{},"fn":container.program(12, data, 0, blockParams),"inverse":container.program(15, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":18,"column":6},"end":{"line":26,"column":6}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = blockParams[7][0]) != null ? lookupProperty(stack1,"nickname") : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams),"inverse":container.program(14, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":19,"column":8},"end":{"line":23,"column":15}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <span class=\"text-block__text\">"
    + container.escapeExpression(container.lambda(((stack1 = blockParams[8][0]) != null ? lookupProperty(stack1,"nickname") : stack1), depth0))
    + "</span>\n";
},"14":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <span class=\"text-block__text\">"
    + container.escapeExpression(container.lambda(((stack1 = blockParams[8][0]) != null ? lookupProperty(stack1,"type") : stack1), depth0))
    + "</span>\n";
},"15":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"text-block__text\">"
    + container.escapeExpression(container.lambda(((stack1 = blockParams[7][0]) != null ? lookupProperty(stack1,"type") : stack1), depth0))
    + "</span>\n      ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"devices") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 1, blockParams, depths),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":1,"column":0},"end":{"line":30,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true,"useBlockParams":true});